import { createSlice } from "../helper";

const eventViewSlice = createSlice({
  name: "eventView",
  initialState: {},
  reducers: {
    replaceState: (_state, action) => {
      return action.payload;
    },
    updateTab: (state, action) => {
      state.filters.tab = action.payload;
    },
    updateEventStatus: (state, action) => {
      state.filters.eventStatus = action.payload;
    },
    updateApprovalStatus: (state, action) => {
      state.filters.approvalStatus = action.payload;
    },
    updatePrograms: (state, action) => {
      state.filters.programs = action.payload;
    },
    updateGroups: (state, action) => {
      state.filters.groups = action.payload;
    },
    updateWhen: (state, action) => {
      state.filters.when = action.payload;
    },
    updateApprovedOn: (state, action) => {
      state.filters.approvedOn = action.payload;
    },
    updateRequestedOn: (state, action) => {
      state.filters.requestedOn = action.payload;
    }
  }
});

export const eventViewActions = eventViewSlice.actions;

export default eventViewSlice.reducer;
